export enum BoxTypeEnum {
    NB1P = 'NB1P',
    NB1A = 'NB1A',
}
